// extracted by mini-css-extract-plugin
export default {"eventWrapper":"TimelineEvent_eventWrapper__YtoyP","eventDate":"TimelineEvent_eventDate__KWCQh","eventText":"TimelineEvent_eventText__cLS5x"};